import { useEffect } from "react"
import { Grid } from "@material-ui/core"
import { Form, FormikProvider, useFormik } from "formik"
import * as Yup from "yup"
import { toast } from "react-toastify"
import { useUpdateAdmin } from "../../services/mutations"
import NCModal from "../../shared/NCModal"
import FormField from "../FormField"
import NCButton from "../../shared/NCButton"
import { useQueryClient } from "react-query"
import NCLoader from "../../shared/NCLoader"
import NCAddress from "../../shared/NCAddress"
import { useTranslation } from "react-i18next"

const EditCompanyModal = ({
  adminId,
  modalState = false,
  handleClose,
  data = {}
}) => {
  const queryClient = useQueryClient()
  const { t } = useTranslation();
  const updateAdminApi = useUpdateAdmin()
  const formik = useFormik({
    initialValues: {
      company_name: data.company_name || "",
      company_address: data.company_address || "",
      company_email_address: data.company_email_address || "",
      latitude: data?.latitude || "",
      longitude: data?.longitude || "",
    },
    validationSchema: Yup.object().shape({}),
    enableReinitialize: true,
    onSubmit(values) {
      if(values.company_address == undefined){
        toast.error(t("subadmin.error.address_required"));
        return;
      }
      updateAdminApi.mutate(
        { ...values, id: adminId },
        {
          onSuccess: () => {
            queryClient.invalidateQueries(["getAdminDetail"])
            queryClient.invalidateQueries(["getAdminAuditLog"])
            toast.success(t("admin.updated"))
            handleClose()
          }
        }
      )
    }
  })

  // Reset unsaved edits whenever the modal is reopened so stale values
  // from a previous open (typed then closed) don't persist.
  useEffect(() => {
    if (modalState) {
      formik.resetForm()
    }
  }, [modalState])

  const companyModal = (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormField
              label={t("admin.company_name")}
              name={"company_name"}
              required={true}
              error={formik?.errors?.company_name}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField
              as={NCAddress}
              label={t("admin.company_address")}
              name={"company_address"}
              onChange={e => {
                formik.setFieldValue("longitude", e?.geometry?.longitude);
                formik.setFieldValue("latitude", e?.geometry?.latitude);
                formik.setFieldValue("company_address", e?.name);
              }}
              required={true}
              error={formik?.errors?.company_address}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField
              label={t("common.email_address")}
              name={"company_email_address"}
              required={true}
              error={formik?.errors?.company_email_address}
            />
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  )
  return (
    <>
      <NCModal
        open={modalState}
        title={t("admin.edit_company")}
        text={companyModal}
        onClose={() => handleClose()}
        submitButton={
          <NCButton
            variant="contained"
            color="primary"
            disableElevation
            onClick={formik.handleSubmit}
            style={{ width: "auto" }}
          >
            {t("common.update")}
          </NCButton>
        }
      />
      {updateAdminApi.isLoading && <NCLoader open={true} />}
    </>
  )
}

export default EditCompanyModal
